import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: 'confirmdialog.component.html',
  standalone: false,
})
export class ConfirmDialogComponent {
  subtitle: string;
  yesOptionTitle: string;
  noOptionTitle: string;
  alternativeOptionTitle: string;
  title: string;
  question: string | string[];
  public dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);
  public data = inject(MAT_DIALOG_DATA);
  reverseLogic: boolean = this.data && this.data.reverseLogic;

  isQuestionAnArray() {
    return Array.isArray(this.question);
  }
}
